/**
 * Check to see if any of the geo-based filter properties are set.
 */
export const geoFilterSet = (filters: any): boolean => {
  return ['userStreet', 'userNeighborhood', 'userCity', 'userState', 'userLat', 'userLong'].some(key => filters && filters[key] && filters[key] !== '');
};
